<template>
    <v-container fluid class="px-0 pt-3">
        <v-layout row wrap>
            <v-flex>
                <pad-lot-list />
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import PadLotList from '@/components/PadLotList'

export default {
    components: { PadLotList }
}
</script>
